
import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../api";
import { Card, CardHeader, Modal, ModalBody, ModalHeader, Table, Row, CardBody, FormGroup, Input, Col, } from "reactstrap";
import { buscarDB } from "service";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";
import { Link, } from "react-router-dom";
import { diagnosticoPDF } from "pdfMake/diagnostico";
import fileDownload from "js-file-download";
import { editDB } from "service";
import { CabeceraFormulariosTratamientoLista, InputUsuario, ComponenteInputBuscar_, CabeceraFormulariosTratamiento, Select1, ComponenteFourRadio, ComponenteCheckTratamiento } from "../input/elementos";
import { INPUT } from "Auth/config";
import toast from "react-hot-toast";
import { start } from "service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEdit, faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { eliminarDB } from "service";

export default function Laboratorio() {

    const [listaDiagnostico, setListaDiagnostico] = useState([])  // LISTA DE DIAGNOSTICOS SOLICITADOS|
    const [diagnosticoData, setDiagnosticoData] = useState([]) // datos de la presente solicitud
    const [listaItemsLaboratorioData, setListaItemsLaboratorioData] = useState([])  // lista para mostrar examenes seleccionados
    const [listaTipoPaciente, setListaTipoPaciente] = useState([])

    const [listaGrupo, setListaGrupo] = useState([])
    const [listaGrupoEtario, setListaGrupoEtario] = useState([])
    const [idGrupo, setIdGrupo] = useState({ campo: null, valido: null });
    const [grupo, setGrupo] = useState({ campo: null, valido: null });
    const [idGrupoEtario, setIdGrupoEtario] = useState({ campo: null, valido: null });
    const [grupoEtario, setGrupoEtario] = useState({ campo: null, valido: null });

    const [modalEdit, setModalEdit] = useState(false)
    const [modalDiagnostico, setModalDiagnostico] = useState(false)

    const [observaciones, setObservaciones] = useState({ campo: null, valido: null })
    const [conclusion, setConclusion] = useState({ campo: null, valido: null })

    const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null });

    const [sangreTotal, setSangreTotal] = useState(null);
    const [fechaMuestra, setFechaMuestra] = useState({ campo: null, valido: null });
    const [resutado, setResultado] = useState({ campo: null, valido: null });
    const [presuntivo, setPresuntivo] = useState({ campo: null, valido: null });

    const [num_micrometodo, setNumeroMicrometodo] = useState(1)


    const [idTipoPaciente, setIdTipoPaciente] = useState({ campo: null, valido: null })
    const [tipoPaciente, setTipoPaciente] = useState({ campo: null, valido: null })
    const [codigo, setCodigo] = useState(null);
    const [ci, setCi] = useState(null);
    const [nombre, setNombre] = useState(null);
    const [ap1, setAp1] = useState(null);
    const [ap2, setAp2] = useState(null);
    const [fechaNac, setFechaNac] = useState(null);
    const [hospital, setHospital] = useState(null);
    const [medico, setMedico] = useState(null);
    const [fechaSolicitud, setFechaSolicitud] = useState(null);





    useEffect(() => {
        listar()
    }, [])

    useEffect(() => {
        if (inputBuscar.campo?.length === 0) listar()
    }, [inputBuscar])


    const initialFormState = {
        campo: null,
        valido: null
    };
    const vaciarDatos = () => {
        const fieldsToReset = {
            setConclusion,
            setObservaciones,
        };
        Object.values(fieldsToReset).forEach(setterFn => {
            setterFn(initialFormState);
        });
        setDiagnosticoData([])
        setModalEdit(false);
    };

    const listar = async () => {
        const data = await buscarDB(API_ENDPOINTS.LABORATORIO.LISTAR);
        setListaDiagnostico(data)
    }

    const buscarPaciente = async () => {
        const data = await buscarDB(API_ENDPOINTS.LABORATORIO.BUSCAR_PACIENTE, { dato: inputBuscar.campo });

        setListaDiagnostico(data)
        if (data.length == 0) toast.error("No se encontraron registros")

    }

    const listarParametros = async (edicion, codigo) => {
        const loadingToast = toast.loading('Cargando información...');
        const data = await start(API_ENDPOINTS.LABORATORIO.LISTAR_PARAMETROS, { codigo })
        if (data[0].length > 0) {
            setListaItemsLaboratorioData(data[0])
        }
        if (data[1].length > 0) {
            setListaTipoPaciente(data[1])
        }
        if (data[2].length > 0) {
            setListaGrupo(data[2])
            listarGruposEtarios(data[2][0].value)
            setIdGrupo({ campo: data[2][0].value, valido: true })
            setGrupo({ campo: data[2][0].label, valido: true })
        }

        toast.dismiss(loadingToast);
        if (edicion == 2) {
            setModalEdit(true)
            setTimeout(() => {
                data[0].forEach(e => {
                    // if (e.item == 1 || e.item == 2) {
                    //     // alert(e.m_resultado + ' Resultado')
                    //     document.getElementById(e.id_items_diagnostico).value = e.m_resultado
                    // }
                    // if (e.item == 3) {
                    //     // alert(e.m_resultado + ' Resultado')
                    //     document.getElementById(e.id_items_diagnostico).value = e.i_resultado
                    // }
                    if (e.item == 4) {
                        // alert(e.h_dilusion + ' Resultado')
                        document.getElementById('h_dilusion' + e.id_items_diagnostico).value = e.h_dilusion
                    }
                    if (e.item == 5) {
                        document.getElementById('e_do' + e.id_items_diagnostico).value = e.e_do
                        document.getElementById('e_cut_off' + e.id_items_diagnostico).value = e.e_cut_off
                    }
                    if (e.item == 7) {
                        document.getElementById('e_do' + e.id_items_diagnostico).value = e.e_do
                        document.getElementById('e_cut_off' + e.id_items_diagnostico).value = e.e_cut_off
                    }
                    if (e.item == 9) {
                        document.getElementById('ifi_titulo' + e.id_items_diagnostico).value = e.ifi_titulo
                        document.getElementById('ifi_cut_off' + e.id_items_diagnostico).value = e.ifi_cut_of
                    }
                })
            }, 1500)

        }
        if (edicion == 3) {
            setModalDiagnostico(true)
        }


    }

    const listarGruposEtarios = async (id_grupo) => {

        const loadingToast = toast.loading('Cargando información...');
        const data = await start(API_ENDPOINTS.LABORATORIO.LISTAR_GRUPO_ETARIO_REPORTES, { id_grupo })
        toast.dismiss(loadingToast);
        setListaGrupoEtario(data)

    }


    const exportPdf = async (output, codigo, paciente) => {
        const data = await start(API_ENDPOINTS.LABORATORIO.VER_PDF, { codigo, paciente })

        if (!data[1][0]?.fecha_toma_muestra) {
            toast.error('Todavia no se asignaron resutados')
            return
        }

        const response = await diagnosticoPDF(output, { paciente: data[0], listaItemsLaboratorio: data[1] })

        if (!response?.success) {
            alert(response?.message);
            return;
        }

        if (output === "b64") {
            const b64toBlob = (
                b64Data,
                contentType = "",
                sliceSize = 512
            ) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (
                    let offset = 0;
                    offset < byteCharacters.length;
                    offset += sliceSize
                ) {
                    const slice = byteCharacters.slice(
                        offset,
                        offset + sliceSize
                    );

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: contentType });
                return blob;
            };
            const blob = b64toBlob(response.content, "application/pdf");
            fileDownload(blob, "diagnostico" + data[0][0].nombre + ' ' + data[0][0].ap1 + ' ' + new Date().toLocaleDateString() + ".pdf");
        }
    }


    const editarResultados = async () => {

        // alert(num_micrometodo)
        await editDB(API_ENDPOINTS.LABORATORIO.MODIFICAR, {
            m_num_micrometodo: listaItemsLaboratorioData.find(e => e.item == 1 || e.item == 2) ? num_micrometodo ? 1 : 2 : null,
            tipo_de_muestra: sangreTotal,
            fecha_toma_muestra: fechaMuestra.campo,
            id_tipo_paciente: idTipoPaciente.campo,
            tipo_paciente: tipoPaciente.campo,
            lista_resultados: listaItemsLaboratorioData,
            conclusion: conclusion.campo,
            observaciones: observaciones.campo || null,
            id_grupo: idGrupo.campo,
            grupo: grupo.campo,
            id_grupo_etario: idGrupoEtario.campo,
            grupo_etario: grupoEtario.campo,
            codigo,
        }, setModalEdit, false, vaciarDatos)
        listar()
    };

    const eliminar = async (codigo) => {
        if (window.confirm('Quitar resultados  ?')) {
            await eliminarDB(API_ENDPOINTS.LABORATORIO.ELIMINAR, { codigo })
            listar()
        }
    }


    return <>
        <div className="contentSimple" >
            <div className="main-container">


                <Card>
                    <CabeceraFormulariosTratamientoLista text={"LISTA DE DIAGNOSTICOS PARA CHAGAS"} />
                    <CardBody>
                        <div className="pt-2 pl-0">
                            <ComponenteInputBuscar_
                                estado={inputBuscar}
                                cambiarEstado={setInputBuscar}
                                name="inputBuscar"
                                ExpresionRegular={INPUT.INPUT_BUSCAR}  //expresion regular
                                placeholder="Escriba para filtrar ..."
                                eventoBoton={buscarPaciente}
                                etiqueta={'Buscar'}
                            />
                        </div>
                        <div style={{ minHeight: '20rem', marginTop: '1rem' }}>
                            <Table className="tablesorter" responsive  >
                                <thead className="text-primary">
                                    <tr>
                                        <th >PACIENTE</th>
                                        <th >APELLIDO PATERNO</th>
                                        <th >APELLIDO MATERNO</th>
                                        <th >C.I.</th>
                                        <th >FECHA SOLICITUD</th>
                                        <th >EST. SOLICITANTE</th>
                                        <th >MEDICO SOLICITANTE</th>
                                        <th >LABORATORIO</th>
                                        <th >LABORATORISTA</th>
                                        <th ></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {listaDiagnostico.map((a, index) => (
                                        <tr key={a.id} style={{
                                            height: '50px', background: index % 2 == 0 ? "#E1EEF4" : 'white',
                                            color: index % 2 == 0 ? "#00496B" : 'white',
                                            borderLeft: a.conclusion ? '5px solid #00AEA4' : '5px solid #fd5d93'
                                        }} className='item'>
                                            <td><div className="tbl-des ">{a.nombre}</div></td>
                                            <td><div className="tbl-des ">{a.ap1}</div></td>
                                            <td><div className="tbl-des ">{a.ap2}</div></td>
                                            <td><div className="tbl-des tbl-bold">{a.ci}</div></td>
                                            <td><div className="tbl-des ">{a.fecha_solicitud}</div></td>

                                            <td>
                                                <div className="tbl-name ">{a.hospital}</div>
                                                <div className="tbl-des">{a.municipio_hospital}</div>
                                            </td>
                                            <td>
                                                <div className="tbl-des ">{a.medico_solicitante}</div>
                                            </td>
                                            <td>
                                                <div className="tbl-name ">{a.laboratorio}</div>
                                                <div className="tbl-des">{a.municipio_laboratorio}</div>
                                            </td>
                                            <td>
                                                <div className="tbl-name ">{a.medico_laboratorio}</div>
                                            </td>
                                            <td>

                                                {a.medico_laboratorio ? <FontAwesomeIcon style={{ color: 'rgb(125, 160, 90)' }} icon={faCheckCircle} /> :
                                                    <FontAwesomeIcon style={{ color: '#f5365c' }} icon={null} />}
                                            </td>
                                            <td>
                                                <div className="btn-tbl-container row">
                                                    {a.edicion ?
                                                        <div
                                                            className="btn-tbl col-3 bg-info"
                                                            onClick={() => {
                                                                setObservaciones({ campo: a.observaciones, valido: true })
                                                                listarParametros(2, a.codigo)
                                                                setCi(a.ci)
                                                                setNombre(a.nombre)
                                                                setAp1(a.ap1)
                                                                setAp2(a.ap2)
                                                                setFechaSolicitud(a.fecha_solicitud)
                                                                setHospital(a.hospital)
                                                                setMedico(a.medico_solicitante)
                                                                setCodigo(a.codigo)
                                                                setSangreTotal(a.tipo_de_muestra)
                                                                setFechaNac(a.fecha_nacimiento)
                                                                setIdTipoPaciente({ campo: a.id_tipo_paciente, valido: true })
                                                                setTipoPaciente({ campo: a.tipo_paciente, valido: true })
                                                                setFechaMuestra({ campo: a.fecha_muestra, valido: true })
                                                                setPresuntivo({ campo: a.presuntivo, valido: true })
                                                                setConclusion({ campo: a.conclusion, valido: true })
                                                                setIdGrupo({ campo: a.id_grupo, valido: true })
                                                                setGrupo({ campo: a.grupo, valido: true })
                                                                setIdGrupoEtario({ campo: a.id_grupo_etario, valido: true })
                                                                setGrupoEtario({ campo: a.grupo_etario, valido: true })
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                                                        </div>
                                                        : <div
                                                            className="btn-tbl col-3 bg-info"
                                                            onClick={() => {
                                                                setObservaciones({ campo: a.observaciones, valido: true })
                                                                listarParametros(2, a.codigo)
                                                                setCi(a.ci)
                                                                setNombre(a.nombre)
                                                                setAp1(a.ap1)
                                                                setAp2(a.ap2)
                                                                setFechaSolicitud(a.fecha_solicitud)
                                                                setHospital(a.hospital)
                                                                setMedico(a.medico_solicitante)
                                                                setCodigo(a.codigo)
                                                                setSangreTotal(a.tipo_de_muestra)
                                                                setFechaNac(a.fecha_nacimiento)
                                                                setIdTipoPaciente({ campo: a.id_tipo_paciente, valido: true })
                                                                setTipoPaciente({ campo: a.tipo_paciente, valido: true })
                                                                setFechaMuestra({ campo: a.fecha_muestra, valido: true })
                                                                setPresuntivo({ campo: a.presuntivo, valido: true })
                                                                setConclusion({ campo: a.conclusion, valido: true })
                                                                setIdGrupo({ campo: a.id_grupo, valido: true })
                                                                setGrupo({ campo: a.grupo, valido: true })
                                                                setIdGrupoEtario({ campo: a.id_grupo_etario, valido: true })
                                                                setGrupoEtario({ campo: a.grupo_etario, valido: true })
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                                                        </div>
                                                    }
                                                    {a.edicion && a.conclusion ?
                                                        <div
                                                            onClick={() => { eliminar(a.codigo) }}
                                                            className="btn-tbl col-3  ml-1" style={{ background: '#FF3D85' }}><FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                                        </div> : null}
                                                    {a.conclusion ?
                                                        < div onClick={() => exportPdf(window.innerWidth < 1100 ? 'b64' : "print", a.codigo, a.id_paciente)}
                                                            className="btn-tbl btn-success col-3  ml-1 " style={{ background: '#00d084' }} ><FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                                                        </div> : null}
                                                </div>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div style={{ padding: '1rem' }}>
                                {listaDiagnostico.length + " Registro(s)"}
                            </div>
                        </div>
                    </CardBody>
                </Card>

            </div>
        </div >



        <Modal
            isOpen={modalEdit}
            toggle={() => { setModalEdit(!modalEdit); vaciarDatos() }}
            className="modal-md"
        >
            <ModalHeader
                toggle={() => { setModalEdit(!modalEdit); vaciarDatos() }}
            >
            </ModalHeader>
            <ModalBody>
                <CabeceraFormulariosTratamiento text={'RESULTADOS DE LABORATORIO'} />
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <p style={{ fontStyle: 'italic', fontWeight: 'bold', marginBottom: '0', marginTop: '10px', fontSize: '12px', color: 'red' }}>{'CODIGO SOLICITUD: ' + codigo}</p>
                </div>
                <div className='cabecera-form mt-3'  >
                    <p>DATOS DEL PACIENTE</p>
                </div>
                <Row >
                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Cédula de identidad'}
                            </label>
                            <Input
                                type="text"
                                value={ci || ""}
                                valido={null}
                                placeholder={'C.I.'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Paciente'}
                            </label>
                            <Input
                                type="text"
                                value={nombre || ""}
                                valido={null}
                                placeholder={'PACIENTE'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Apellido Paterno'}
                            </label>
                            <Input
                                type="text"
                                value={ap1 || ""}
                                valido={null}
                                placeholder={'Apellido Paterno'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Apellido Materno'}
                            </label>
                            <Input
                                type="text"
                                value={ap2 || ""}
                                valido={null}
                                placeholder={'apellido materno'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'fecha Nacimiento'}
                            </label>
                            <Input
                                type="text"
                                value={fechaNac || ""}
                                valido={null}
                                placeholder={'Fecha Nacimiento'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                </ Row>
                <Col md={12}>
                    <FormGroup>
                        <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                            {'DIAGNOSTICO PRESUNTIVO'}
                        </label>
                        <Input
                            type="text"
                            value={presuntivo.campo || ""}
                            valido={null}
                            placeholder={'DIAG. PRESUNTIVO'}
                            toUpperCase
                            disabled
                        />
                    </FormGroup>
                </Col>
                <div className="row">
                    <div className="col-md-6" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idGrupo}
                            cambiarEstado={setIdGrupo}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Congenito/crónico'}
                            msg={"el formato no es valido"}
                            lista={listaGrupo}
                            name={'id_grupo'}
                            label={setGrupo}
                            funcion={listarGruposEtarios}

                        />
                    </div>
                    <div className="col-md-6" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idGrupoEtario}
                            cambiarEstado={setIdGrupoEtario}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Grupo Etario'}
                            msg={"el formato no es valido"}
                            lista={listaGrupoEtario}
                            name={'id_grupo_etario'}
                            label={setGrupoEtario}
                        />
                    </div>
                </div>
                <div style={{
                    marginTop: '10px'
                }}  >
                    <p style={{
                        color: '#5e72e4',
                        //   fontWeight:'600'
                        marginBottom: '0',
                        fontSize: '15px',
                        borderBottom: '1px solid #17a2b8'
                    }}>   EXAMENES SOLICITADOS</p>
                </div>
                <Row className=" mt-1">
                    <Col md={6} >
                        <ComponenteFourRadio
                            label={'TIPO DE MUESTRA'}
                            label_A='Sangre Total'
                            label_B='Suero'
                            label_C='Plasma'
                            label_D='LCR'
                            estado={sangreTotal}
                            cambiarEstado={setSangreTotal}
                            col={12}
                        />
                    </Col>
                    <Col md={3} className="mt-1" >
                        <InputUsuario
                            estado={fechaMuestra}
                            cambiarEstado={setFechaMuestra}
                            name={'fecha_muestra'}
                            ExpresionRegular={INPUT.FECHA}
                            etiqueta={'fecha toma muestra: '}
                            msg={"El formato no es válido"}
                            tipo="date"
                        />
                    </Col>
                    <Col md={3}>
                        <Select1
                            estado={idTipoPaciente}
                            cambiarEstado={setIdTipoPaciente}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Tipo Paciente'}
                            msg={"el formato no es valido"}
                            lista={listaTipoPaciente}
                            name={'id_tipo_paciente'}
                            label={setTipoPaciente}
                        // importante={false}
                        />
                    </Col>


                </Row>

                <div className="row g-3" style={{ justifyContent: 'center', paddingBottom: '7px', }}>
                    {
                        listaItemsLaboratorioData.map((e, index) => (
                            e.item == 1 || e.item == 2 ?
                                <Col md={6} key={index}>
                                    <FormGroup>
                                        <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>{e.items_diagnostico}</label>
                                        <select
                                            key={index}
                                            style={{
                                                display: 'block',
                                                background: 'white',
                                                width: '100%',
                                                height: '37px',
                                                borderRadius: '5px',
                                                fontSize: '11px',
                                                fontWeight: '13px',
                                                border: '1px solid #5e72e4',
                                                color: '#222a42'
                                            }}
                                            name={e.id_items_diagnostico}
                                            id={e.id_items_diagnostico}
                                            onChange={(r) => {

                                                if (r.target.value == 1) {
                                                    e.m_resultado = 1
                                                }
                                                if (r.target.value == 2) {
                                                    e.m_resultado = 2
                                                }
                                                if (r.target.value == 0) {
                                                    e.m_resultado = 0
                                                }
                                            }}
                                        >
                                            <option value={0}>Seleccione</option>
                                            <option value={1}>POSITIVO  </option>
                                            <option value={2}>NEGATIVO  </option>
                                        </select>
                                    </FormGroup>
                                    {/* {num_micrometodo} */}
                                    <ComponenteCheckTratamiento
                                        label='micrometodo'
                                        label_A='Primer micrometodo'
                                        label_B='segundo micrometodo'
                                        estado={num_micrometodo}
                                        cambiarEstado={setNumeroMicrometodo}
                                        col={12}
                                    />

                                </Col> :
                                e.item == 3 ?
                                    <Col md={6} key={index}>
                                        <FormGroup>
                                            <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>{e.items_diagnostico}</label>
                                            <select
                                                key={index}
                                                style={{
                                                    display: 'block',
                                                    background: 'white',
                                                    width: '100%',
                                                    height: '37px',
                                                    borderRadius: '5px',
                                                    fontSize: '11px',
                                                    fontWeight: '13px',
                                                    border: '1px solid #5e72e4',
                                                    color: '#222a42'

                                                }}
                                                name={`items_diagnostico_${e.id_items_diagnostico}`}
                                                onChange={(r) => {

                                                    if (r.target.value == 1) {
                                                        e.i_resultado = 1
                                                    }
                                                    if (r.target.value == 2) {
                                                        e.i_resultado = 2
                                                    }
                                                    if (r.target.value == 3) {
                                                        e.i_resultado = 3
                                                    }
                                                    if (r.target.value == 0) {
                                                        e.i_resultado = 0
                                                    }
                                                }}
                                            >
                                                <option value={0}>Seleccione</option>
                                                <option value={1}>REACTIVO  </option>
                                                <option value={2}>NO REACTIVO  </option>
                                                <option value={3}>DUDOSO  </option>
                                            </select>
                                        </FormGroup>
                                    </Col>

                                    :
                                    e.item == 4 ?
                                        <Col md={12} className="mt-3" key={index}>
                                            <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>
                                                {e.items_diagnostico}
                                            </label>
                                            <Row>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'DILUSION'}</label>
                                                        <input
                                                            key={index}
                                                            style={{
                                                                display: 'block',
                                                                background: 'white',
                                                                width: '100%',
                                                                height: '37px',
                                                                borderRadius: '5px',
                                                                fontSize: '11px',
                                                                fontWeight: '13px',
                                                                border: '1px solid #5e72e4',
                                                                color: '#222a42'

                                                            }}
                                                            name={`h_dilusion${e.id_items_diagnostico}`}
                                                            id={`h_dilusion${e.id_items_diagnostico}`}
                                                            onChange={(r) => {
                                                                e.h_dilusion = r.target.value
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'LINEA DE CORTE'}</label>
                                                        <select
                                                            key={index}
                                                            style={{
                                                                display: 'block',
                                                                background: 'white',
                                                                width: '100%',
                                                                height: '37px',
                                                                borderRadius: '5px',
                                                                fontSize: '11px',
                                                                fontWeight: '13px',
                                                                border: '1px solid #5e72e4',
                                                                color: '#222a42'

                                                            }}
                                                            name={`${e.id_items_diagnostico}`}
                                                            onChange={(r) => {

                                                                if (r.target.value == 1) {
                                                                    e.h_linea_de_corte = 1
                                                                }
                                                                if (r.target.value == 2) {
                                                                    e.h_linea_de_corte = 2
                                                                }
                                                                if (r.target.value == 0) {
                                                                    e.h_linea_de_corte = 0
                                                                }
                                                            }}
                                                        >
                                                            <option value={0}>Seleccione</option>
                                                            <option value={1}>1/16  </option>
                                                            <option value={2}>1/128  </option>
                                                        </select>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'RESULTADO'}</label>
                                                        <select
                                                            key={index}
                                                            style={{
                                                                display: 'block',
                                                                background: 'white',
                                                                width: '100%',
                                                                height: '37px',
                                                                borderRadius: '5px',
                                                                fontSize: '11px',
                                                                fontWeight: '13px',
                                                                border: '1px solid #5e72e4',
                                                                color: '#222a42'

                                                            }}
                                                            name={`${e.id_items_diagnostico}`}
                                                            onChange={(r) => {

                                                                if (r.target.value == 1) {
                                                                    e.h_resultado = 1
                                                                }
                                                                if (r.target.value == 2) {
                                                                    e.h_resultado = 2
                                                                }
                                                                if (r.target.value == 3) {
                                                                    e.h_resultado = 3
                                                                }
                                                                if (r.target.value == 0) {
                                                                    e.h_resultado = 0
                                                                }
                                                            }}
                                                        >
                                                            <option value={0}>Seleccione</option>
                                                            <option value={1}>REACTIVO  </option>
                                                            <option value={2}>NO REACTIVO  </option>
                                                            <option value={3}>INDETERMINADO  </option>
                                                        </select>
                                                    </FormGroup>
                                                </Col>

                                            </Row>
                                        </Col> :

                                        e.item == 5 ?
                                            <Col md={12} className="mt-3" key={index}>
                                                <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>
                                                    {e.items_diagnostico}
                                                </label>
                                                <Row>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'D.O'}</label>
                                                            <input
                                                                key={index}
                                                                style={{
                                                                    display: 'block',
                                                                    background: 'white',
                                                                    width: '100%',
                                                                    height: '37px',
                                                                    borderRadius: '5px',
                                                                    fontSize: '11px',
                                                                    fontWeight: '13px',
                                                                    border: '1px solid #5e72e4',
                                                                    color: '#222a42'

                                                                }}
                                                                name={`e_do${e.id_items_diagnostico}`}
                                                                id={`e_do${e.id_items_diagnostico}`}
                                                                onChange={(r) => {
                                                                    e.e_do = r.target.value
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'CUT-OFF'}</label>
                                                            <input
                                                                key={index}
                                                                style={{
                                                                    display: 'block',
                                                                    background: 'white',
                                                                    width: '100%',
                                                                    height: '37px',
                                                                    borderRadius: '5px',
                                                                    fontSize: '11px',
                                                                    fontWeight: '13px',
                                                                    border: '1px solid #5e72e4',
                                                                    color: '#222a42'

                                                                }}
                                                                name={`e_cut_off${e.id_items_diagnostico}`}
                                                                id={`e_cut_off${e.id_items_diagnostico}`}
                                                                onChange={(r) => {
                                                                    e.e_cut_off = r.target.value
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'RESULTADO'}</label>
                                                            <select
                                                                key={index}
                                                                style={{
                                                                    display: 'block',
                                                                    background: 'white',
                                                                    width: '100%',
                                                                    height: '37px',
                                                                    borderRadius: '5px',
                                                                    fontSize: '11px',
                                                                    fontWeight: '13px',
                                                                    border: '1px solid #5e72e4',
                                                                    color: '#222a42'

                                                                }}
                                                                name={`${e.id_items_diagnostico}`}
                                                                onChange={(r) => {

                                                                    if (r.target.value == 1) {
                                                                        e.e_resultado = 1
                                                                    }
                                                                    if (r.target.value == 2) {
                                                                        e.e_resultado = 2
                                                                    }
                                                                    if (r.target.value == 3) {
                                                                        e.e_resultado = 3
                                                                    }
                                                                    if (r.target.value == 0) {
                                                                        e.e_resultado = 0
                                                                    }
                                                                }}
                                                            >
                                                                <option value={0}>Seleccione</option>
                                                                <option value={1}>REACTIVO  </option>
                                                                <option value={2}>NO REACTIVO  </option>
                                                                <option value={3}>INDETERMINADO  </option>
                                                            </select>
                                                        </FormGroup>
                                                    </Col>

                                                </Row>
                                            </Col> :
                                            e.item == 7 ?
                                                <Col md={12} className="mt-3" key={index}>
                                                    <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>
                                                        {e.items_diagnostico}
                                                    </label>
                                                    <Row>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'D.O'}</label>
                                                                <input
                                                                    key={index}
                                                                    style={{
                                                                        display: 'block',
                                                                        background: 'white',
                                                                        width: '100%',
                                                                        height: '37px',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '13px',
                                                                        border: '1px solid #5e72e4',
                                                                        color: '#222a42'

                                                                    }}
                                                                    name={`e_do${e.id_items_diagnostico}`}
                                                                    id={`e_do${e.id_items_diagnostico}`}
                                                                    onChange={(r) => {
                                                                        e.e_do = r.target.value
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'CUT-OFF'}</label>
                                                                <input
                                                                    key={index}
                                                                    style={{
                                                                        display: 'block',
                                                                        background: 'white',
                                                                        width: '100%',
                                                                        height: '37px',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '13px',
                                                                        border: '1px solid #5e72e4',
                                                                        color: '#222a42'

                                                                    }}
                                                                    name={`e_cut_off${e.id_items_diagnostico}`}
                                                                    id={`e_cut_off${e.id_items_diagnostico}`}
                                                                    onChange={(r) => {
                                                                        e.e_cut_off = r.target.value
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'RESULTADO'}</label>
                                                                <select
                                                                    key={index}
                                                                    style={{
                                                                        display: 'block',
                                                                        background: 'white',
                                                                        width: '100%',
                                                                        height: '37px',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '13px',
                                                                        border: '1px solid #5e72e4',
                                                                        color: '#222a42'

                                                                    }}
                                                                    name={`${e.id_items_diagnostico}`}
                                                                    onChange={(r) => {

                                                                        if (r.target.value == 1) {
                                                                            e.e_resultado = 1
                                                                        }
                                                                        if (r.target.value == 2) {
                                                                            e.e_resultado = 2
                                                                        }
                                                                        if (r.target.value == 3) {
                                                                            e.e_resultado = 3
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value={0}>Seleccione</option>
                                                                    <option value={1}>REACTIVO  </option>
                                                                    <option value={2}>NO REACTIVO  </option>
                                                                    <option value={3}>INDETERMINADO  </option>
                                                                </select>
                                                            </FormGroup>
                                                        </Col>

                                                    </Row>
                                                </Col> :
                                                e.item == 9 ?
                                                    <Col md={12} className="mt-3" key={index}>
                                                        <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', color: index % 2 == 0 ? '#17a2b8' : '#fd5d93' }}>
                                                            {e.items_diagnostico}
                                                        </label>
                                                        <Row>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'TITULO'}</label>
                                                                    <input
                                                                        key={index}
                                                                        style={{
                                                                            display: 'block',
                                                                            background: 'white',
                                                                            width: '100%',
                                                                            height: '37px',
                                                                            borderRadius: '5px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '13px',
                                                                            border: '1px solid #5e72e4',
                                                                            color: '#222a42'

                                                                        }}
                                                                        name={`ifi_titulo${e.id_items_diagnostico}`}
                                                                        id={`ifi_titulo${e.id_items_diagnostico}`}
                                                                        onChange={(r) => {
                                                                            e.ifi_titulo = r.target.value
                                                                        }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'CUT-OFF'}</label>
                                                                    <input
                                                                        key={index}
                                                                        style={{
                                                                            display: 'block',
                                                                            background: 'white',
                                                                            width: '100%',
                                                                            height: '37px',
                                                                            borderRadius: '5px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '13px',
                                                                            border: '1px solid #5e72e4',
                                                                            color: '#222a42'

                                                                        }}
                                                                        name={`ifi_cut_off${e.id_items_diagnostico}`}
                                                                        id={`ifi_cut_off${e.id_items_diagnostico}`}
                                                                        onChange={(r) => {
                                                                            e.ifi_cut_of = r.target.value
                                                                        }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <label style={{ marginBottom: '0', fontSize: '12px', fontWeight: 'bold', }}>{'RESULTADO'}</label>
                                                                    <select
                                                                        key={index}
                                                                        style={{
                                                                            display: 'block',
                                                                            background: 'white',
                                                                            width: '100%',
                                                                            height: '37px',
                                                                            borderRadius: '5px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '13px',
                                                                            border: '1px solid #5e72e4',
                                                                            color: '#222a42'

                                                                        }}
                                                                        name={`${e.id_items_diagnostico}`}
                                                                        onChange={(r) => {

                                                                            if (r.target.value == 1) {
                                                                                e.ifi_resultado = 1
                                                                            }
                                                                            if (r.target.value == 2) {
                                                                                e.ifi_resultado = 2
                                                                            }
                                                                            if (r.target.value == 3) {
                                                                                e.ifi_resultado = 3
                                                                            }
                                                                            if (r.target.value == 0) {
                                                                                e.ifi_resultado = 0
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value={0}>Seleccione</option>
                                                                        <option value={1}>REACTIVO  </option>
                                                                        <option value={2}>NO REACTIVO  </option>
                                                                        <option value={3}>INDETERMINADO  </option>
                                                                    </select>
                                                                </FormGroup>
                                                            </Col>

                                                        </Row>
                                                    </Col> :
                                                    null
                        ))
                    }
                </div>


                <Row>
                    <div className="col-md-6 mt-4" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={conclusion}
                            cambiarEstado={setConclusion}
                            ExpresionRegular={INPUT.ID} //expresion regular
                            etiqueta={'Conclusion'}
                            lista={[{ value: 0, label: 'SELECCIONAR' }, { value: 1, label: 'POSITIVO' }, { value: 2, label: 'NEGATIVO' }, { value: 3, label: 'INDETERMINADO' },]}
                            name={'conclusion'}
                        />
                    </div>

                    <div className="col-md-12" style={{ marginBottom: '.7rem' }}>
                        <InputUsuario
                            estado={observaciones}
                            name={'observaciones'}
                            tipo="textarea"
                            cambiarEstado={setObservaciones}
                            ExpresionRegular={INPUT.TEXTO}
                            etiqueta={'Observaciones'}
                            msg={"el formato no es valido"}
                            importante={false}
                        />
                    </div>

                </Row>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
                    <div className="hero-section m-1 mt-3 mb-3" >
                        <button onClick={() => editarResultados()} className="btn btn-success" >Actualizar resultados</button>
                    </div>
                </div>

            </ModalBody>
        </Modal>

    </>
}
